
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const wareHouseService = {
    wareHouseList,
    wareHouseDetails,
  submitWareHouse

};

//========= WareHouse =============== 
async function  wareHouseList() {
    return apiClient.get(`/warehouse/warehouse-list`, authHeader());
}

async function  wareHouseDetails(salesOrderId) {
    return apiClient.get(`/warehouse/warehouse-details/${salesOrderId}`, authHeader());
}

async function  submitWareHouse(formData) {
    return apiClient.post(`/warehouse/submit-warehouse`,formData, authHeader());
}


//========= WareHouse  END  =============================










// ============= STOCK ADJUSTMENT END============



















